module.exports = __webpack_public_path__ + "img/pdf.31ecc4fd.svg";